import { render, staticRenderFns } from "./CampusEdit.vue?vue&type=template&id=916732ee"
import script from "../../controllers/campus/campus-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus/campus-edit.js?vue&type=script&lang=js&external"
import style0 from "./CampusEdit.vue?vue&type=style&index=0&id=916732ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports